import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map, mergeMap } from 'rxjs/operators';
import { UserClientLinkService } from '../services/UserClientLinkService';
import * as A from './client-links.reducer';

@Injectable()
export class ClientLinksEffects {
  constructor(private actions$: Actions, private service: UserClientLinkService) {}
  load$ = createEffect(() => this.actions$.pipe(ofType(A.linksOpen, A.linksLoad, A.linksSaved),
    mergeMap(a => this.service.list(a.userId).pipe(
      map(links => A.linksLoaded({ scope: a.scope, links })),
      catchError(() => of(A.linksError({ scope: a.scope, message: 'Kopplingarna kunde inte hämtas. Försök igen.' })))
    ))));
  save$ = createEffect(() => this.actions$.pipe(ofType(A.linksSave),
    concatMap(a => this.service.save(a.userId, a.id, a.input).pipe(
      map(() => A.linksSaved({ scope: a.scope, userId: a.userId, organizationId: a.input.OrganizationId })),
      catchError(error => of(A.linksError({ scope: a.scope, message: this.saveError(error) })))
    ))));
  delete$ = createEffect(() => this.actions$.pipe(ofType(A.linksDelete),
    concatMap(a => this.service.remove(a.userId, a.id).pipe(
      map(() => A.linksSaved({ scope: a.scope, userId: a.userId })),
      catchError(() => of(A.linksError({ scope: a.scope, message: 'Kopplingen kunde inte tas bort. Försök igen.' })))
    ))));
  search$ = createEffect(() => this.actions$.pipe(ofType(A.linksSearch),
    mergeMap(a => this.service.search(a.userId, a.term).pipe(
      map(organizations => A.linksOrganizations({ scope: a.scope, request: a.request, organizations })),
      catchError(() => of(A.linksOrganizations({ scope: a.scope, request: a.request, organizations: [], error: 'Organisationssökningen misslyckades. Försök igen.' })))
    ))));
  private saveError(error: any): string {
    if (error.status === 409) return 'Uppdragsgivaren eller detta ID är redan registrerat.';
    if (error.status === 400) return 'Välj en organisation som uppdragsgivare och ange ett ID med 1–120 tecken.';
    return 'Kopplingen kunde inte sparas. Försök igen.';
  }
}
